<template>
  <v-dialog v-model="localValue" max-width="500" persistent>
    <v-card>
      <v-card-title class="text-h6 font-weight-bold">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <div class="body-1">
          {{ text }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text :disabled="loading" @click="close"> Annuleren </v-btn>

        <v-btn
          color="error"
          depressed
          :loading="loading"
          :disabled="loading"
          @click="confirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseConfirmDeletionModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Verwijderen bevestigen",
    },
    text: {
      type: String,
      default: "Weet je zeker dat je dit item wilt verwijderen?",
    },
    confirmText: {
      type: String,
      default: "Verwijderen",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  watch: {
    value(val) {
      if (val) {
        window.addEventListener("keydown", this.handleKeydown);
      } else {
        window.removeEventListener("keydown", this.handleKeydown);
      }
    },
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },

  methods: {
    close() {
      if (this.loading) return;
      this.localValue = false;
    },

    confirm() {
      if (this.loading) return;
      this.$emit("confirm");
    },

    handleKeydown(event) {
      if (!this.localValue) return;

      if (event.key === "Escape") {
        this.close();
      }

      if (event.key === "Enter") {
        event.preventDefault();
        this.confirm();
      }
    },
  },
};
</script>
